import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AssignCdsCC } from '../models/assign.model';
import { environment } from 'src/environments/environment';
import * as globals from '../training/globals';

const baseUrl = `${environment.apis.connect}/${globals.ASSIGNMENTS}`;

@Injectable({
  providedIn: 'root',
})

export class AssignmentsService {
  constructor(
    private http: HttpClient) {
  }

  getAssignments(): Observable<AssignCdsCC[]> {
    return this.http.get<AssignCdsCC[]>(`${baseUrl}/${globals.GET_ASSIGNMENTS}`);
  }

  getAssignment(account_id: number): Observable<AssignCdsCC> {
    return this.http.get<AssignCdsCC>(`${baseUrl}/${globals.GET_ASSIGNMENT}?${globals.ACCOUNT_ID}=${account_id}&${globals.IS_ACCOUNT_USER_ACCESS}=${globals.TRUE}`);
  }

  getAssignmentGuid(account_id: string): Observable<AssignCdsCC> {
    return this.http.get<AssignCdsCC>(`${baseUrl}/${globals.GET_ASSIGNMENT_GUID}?${globals.ACCOUNT_ID}=${account_id}&${globals.IS_ACCOUNT_USER_ACCESS}=${globals.TRUE}`);
  }

  getAssignmentsInValid(data: any): Observable<any> {
    return this.http.patch<any>(`${baseUrl}/${globals.GET_ASSIGNMENTS_INVALID}`, data);
  }
  
  updateAssignment(data: AssignCdsCC): Observable<any> {
    return this.http.post<any>(`${baseUrl}/${globals.UPDATE_ASSIGNMENT}`, data);
  }
}
